import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/translations";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const links = [
    { to: "/", label: t.nav.home },
    { to: "/services", label: t.nav.services },
    { to: "/cabinet", label: t.nav.about },
    { to: "/contact", label: t.nav.contact },
  ];

  const info = [
    { icon: Phone, label: t.contactPage.info.phone, value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, "")}` },
    { icon: Mail, label: t.contactPage.info.email, value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: MapPin, label: t.contactPage.info.web, value: CONTACT.web, href: null },
  ];

  return (
    <footer className="relative bg-navy text-ivory overflow-hidden grain" data-testid="footer">
      <div className="relative max-w-[1500px] mx-auto px-6 lg:px-12 pt-24 pb-12">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1.2fr] gap-14 lg:gap-20">
          <div>
            <Logo light className="h-12" />
            <p className="mt-8 font-serif text-2xl lg:text-3xl leading-snug text-ivory/90 max-w-md">
              {t.footer.tagline}
            </p>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-gold mb-6">{t.footer.nav}</p>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="nav-link text-ivory/70 hover:text-gold text-sm" data-testid={`footer-nav-${l.to === "/" ? "home" : l.to.slice(1)}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-gold mb-6">{t.footer.contactTitle}</p>
            <ul className="space-y-4">
              {info.map((it) => (
                <li key={it.label} className="flex items-start gap-3">
                  <it.icon size={16} className="text-gold mt-1 shrink-0" strokeWidth={1.5} />
                  {it.href ? (
                    <a href={it.href} className="text-ivory/80 hover:text-gold text-sm transition-colors break-all" data-testid={`footer-${it.label}`}>{it.value}</a>
                  ) : (
                    <span className="text-ivory/80 text-sm">{it.value}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="gold-rule mt-16 mb-8 opacity-40" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] uppercase tracking-[0.18em] text-ivory/50">
          <span>© {year} EMG Performance 360</span>
          <span>{t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
};
